import usePrivateAxios from '@/common/api/usePrivateAxios'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { UpdateGeneralPoliticsSchema } from '@/features/privateCompanies/schemas/politics/updateGeneralPolitics.schema'
import { useMutation } from '@tanstack/react-query'
import { CompanyData } from '@/features/companies/types/companies.type'
import { mapToDeletion } from '@/common/utils/railsHelpers'

interface UseUpdateGeneralPolitics {
  companyId?: string
  company?: CompanyData
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateGeneralPolitics = ({ companyId, company, onSuccess, onError }: UseUpdateGeneralPolitics) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateGeneralPolitics'],
    mutationFn: async (data: UpdateGeneralPoliticsSchema) => {
      const payload = {
        printer_machine_id: data.company?.printer_machine_id?.value || undefined,
        time_zone_id: data.company?.time_zone_id?.value || undefined,
        price_survey_mode: data.company?.price_survey_mode?.value || undefined,
        allowed_establishment_flags_attributes: data.company.allowed_establishment_flags
          ? getRailsUpdate(
            company?.allowed_establishment_flags || [],
            data.company.allowed_establishment_flags || [],
            (data) => data.establishment_flag.id,
            (data) => data.value,
            mapToDeletion,
            (x) => ({ establishment_flag_id: x.value }),
          )
          : undefined,
        establishment_blocked_flags_mode: data.company.establishment_blocked_flags_mode?.value || undefined,
        usage_declaration_mode: data.company.usage_declaration_mode?.value || undefined,
        tracker_integration_mode: data.company.tracker_integration_mode?.value || undefined,
        create_usage_declaration_mode: data.company.create_usage_declaration_mode?.value || undefined,
        update_equipment_log_reason_requirement: data.company.update_equipment_log_reason_requirement?.value || undefined,
        update_user_log_reason_requirement: data.company.update_user_log_reason_requirement?.value || undefined,
        equipment_driver_license_requirements_for_consumptions: data.company.equipment_driver_license_requirements_for_consumptions?.value || undefined,
        cards_quota: data.cards_quota ? Number(data.cards_quota?.replace(/[.]/g, '')) : undefined,
        require_bill_review: data.company?.require_bill_review?.value || undefined,
      }

      await privateAxios.put(`/client/companies/${companyId}/update_politics_general_information`, {
        company: payload,
      })
    },
    onSuccess,
    onError,
  })
}
